import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"row":"","wrap":""}},[_c(VFlex,{attrs:{"xs12":"","md5":""}},[_c(VLayout,{attrs:{"column":""}},[_c(VFlex,{attrs:{"ma-2":""}},[_c('FCCRunDetails')],1)],1)],1),_c(VFlex,{attrs:{"xs12":"","md7":""}},[_c(VLayout,{attrs:{"column":""}},[_c(VFlex,{attrs:{"ma-2":""}},[_c('FCCRunPenalities')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }